<aumico-table-with-form
    [options]="tableOptions"
    [editable]="editable"
    [displayedColumns]="displayedColumns"
    [data]="EquityData.rows"
    [viewMode]="viewMode"
    [additionalHeaders]="additionalHeaders"
    [editableHeaders]="viewMode === viewModeEnum.EDIT"
    [textTitle]="tableTitle"
    [hasTotalRow]="ComponentOptions.totalRow"
    (formChange)="onFormChange($event)"
    [totalRowText]="totalRowTextCell"
    [todoHighlight]="highlightTodos"
    [isReferenced]="addReferencing"
    [isNumbered]="addNumbering"
    [tableNumber]="tableNumber"
    (onAddNumberingClicked)="onAddNumberingClicked()"
    (onAddReferencingClicked)="onAddReferencingClicked()"
></aumico-table-with-form>
